import {frontend} from 'pageflow-scrolled/frontend';

import {Highlights} from './Highlights';

frontend.contentElementTypes.register('highlights', {
  component: Highlights,
  lifecycle: true
});
